import Hero from "../components/sections/Hero";
import TickerMarquee from "../components/sections/Marquee";
import Trust from "../components/sections/Trust";
import TrustedBy from "../components/sections/TrustedBy";
import ServicesPreview from "../components/sections/ServicesPreview";
import Savings from "../components/sections/Savings";
import Gallery from "../components/sections/Gallery";
import CityStrip from "../components/CityStrip";
import Testimonials from "../components/sections/Testimonials";
import LeadSection from "../components/sections/LeadSection";

export default function Home() {
  return (
    <main data-testid="home-page">
      <Hero />
      <TickerMarquee />
      <Trust />
      <TrustedBy />
      <ServicesPreview />
      <Savings />
      <Gallery />
      <CityStrip />
      <Testimonials />
      <LeadSection />
    </main>
  );
}
